module.exports = __webpack_public_path__ + "static/media/logopgm.2ac0908b.svg";